import { render, staticRenderFns } from "./TwoWordStory.vue?vue&type=template&id=2f246ec1&scoped=true"
import script from "./TwoWordStory.vue?vue&type=script&lang=js"
export * from "./TwoWordStory.vue?vue&type=script&lang=js"
import style0 from "./TwoWordStory.vue?vue&type=style&index=0&id=2f246ec1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f246ec1",
  null
  
)

export default component.exports